import React from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { MaintenanceState } from "api/automationTypes";
import { BlockStandard } from "components/admin/BlockStandard";
import { PhotoUploadGrid } from "./PhotoUploadGrid";
import { DeleteCTA } from "components/MUIExtensions/DeleteCTA";

const CONSERVATION_STATES = Object.values(MaintenanceState);

export const OtherCargoDetail = ({
  data,
  position,
  onChange,
  onDelete,
}: OtherCargoDetailProps) => {
  const handleFieldChange =
    (field: keyof OtherCargoDetailItem) =>
    ({ target }) => {
      onChange({ ...data, [field]: target.value });
    };

  const handlePhotosChange = (photos: File[]) => {
    onChange({ ...data, images: photos });
  };

  return (
    <BlockStandard>
      <TextField
        fullWidth
        label="Descrição do sistema"
        placeholder="Informe"
        value={data.systemDescription || ""}
        onChange={handleFieldChange("systemDescription")}
      />

      <TextField
        fullWidth
        label="Tipo de equipamento/tecnologia"
        placeholder="Informe"
        value={data.technologyType || ""}
        onChange={handleFieldChange("technologyType")}
      />

      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        gap={2}
      >
        <TextField
          label="Potência nominal (W)"
          placeholder="Informe"
          value={data.ratedPower || ""}
          onChange={handleFieldChange("ratedPower")}
          sx={{ flex: 1 }}
        />

        <TextField
          label="Potência instalada (kW)"
          placeholder="Ex.: 1"
          value={data.installedCapacity || ""}
          onChange={handleFieldChange("installedCapacity")}
          sx={{ flex: 1 }}
        />
      </Grid>

      <FormControl fullWidth>
        <InputLabel id={`select-conservation-${position}`}>
          Estado de conservação
        </InputLabel>
        <Select
          labelId={`select-conservation-${position}`}
          label="Estado de conservação"
          value={data.conservationStatus || ""}
          onChange={handleFieldChange("conservationStatus")}
        >
          {CONSERVATION_STATES.map((option) => (
            <MenuItem value={option} key={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        fullWidth
        multiline
        minRows={3}
        label="Observações"
        placeholder="Descreva sua observação"
        value={data.obs || ""}
        onChange={handleFieldChange("obs")}
      />

      <PhotoUploadGrid
        photos={data.images}
        onPhotosChange={handlePhotosChange}
        buttonText="Enviar foto"
      />

      {onDelete && <DeleteCTA onDeleteConfirmed={onDelete} />}
    </BlockStandard>
  );
};

export type OtherCargoDetailItem = {
  systemDescription: string;
  technologyType: string;
  ratedPower: string;
  installedCapacity: string;
  conservationStatus: MaintenanceState | "";
  obs: string;
  images: File[];
};

export const emptyOtherCargo: OtherCargoDetailItem = {
  systemDescription: "",
  technologyType: "",
  ratedPower: "",
  installedCapacity: "",
  conservationStatus: "",
  obs: "",
  images: [],
};

export type OtherCargoDetailProps = {
  data: OtherCargoDetailItem;
  position: number;
  onChange: (cargo: OtherCargoDetailItem) => void;
  onDelete?: () => void;
};
